import { useQuery, gql, QueryResult, OperationVariables } from '@apollo/client'

const CHATBOT_PERMISSION = gql`
  query checkChatbotPermission {
    checkChatbotPermission
  }
`
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useChatbotPermission = (): QueryResult<any, OperationVariables> => {
  return useQuery(CHATBOT_PERMISSION)
}
